export default "__VITE_ASSET__685647dc__"